//PACKS
import React, { useState } from "react";
import ScrollIntoView from "react-scroll-into-view";

//COMPONENTS
import Hamburger from "./Hamburger";

//STYLES
import "../styles/navbar.scss";

//ASSETS
import logo from "../assets/set_logo.svg";
import hamburger from "../assets/hamburger.svg";

export default function Navbar(props) {
  //STATE
  const [toggle, setToggle] = useState(false);

  function handleToggle() {
    setToggle(!toggle);
  }

  function renderHamburger() {
    if (props.device !== "desktop") {
      return (
        <Hamburger toggle={toggle} handleToggle={handleToggle.bind(this)} />
      );
    }
  }

  return (
    <>
      <div className="navbarContainer">
        <div className="navbar">
          <ScrollIntoView selector="#hero">
            <img className="navLogo" src={logo} alt="navLogo" />
          </ScrollIntoView>
          {props.device === "desktop" ? (
            <div className="navButtons">
              <ScrollIntoView selector="#mission">
                <li>mission</li>
              </ScrollIntoView>
              <ScrollIntoView selector="#products">
                <li>prodotti</li>
              </ScrollIntoView>
              <ScrollIntoView selector="#contact">
                <li>contatto</li>
              </ScrollIntoView>
            </div>
          ) : (
            <div className="navHamburgerContainer">
              <img
                className="navHamburger"
                src={hamburger}
                alt="hamburger"
                onClick={() => {
                  setToggle(!toggle);
                }}
              />
            </div>
          )}
        </div>
      </div>
      {renderHamburger()}
    </>
  );
}
